
import { BenModalFn } from '@/common/BenModalFn'
import { VueFn } from '@/common/VueFn'
import { reactive, toRefs, onMounted, nextTick, watchEffect, watch } from 'vue'
import { WimFn } from './components/service/WimFn'
import { BenFn } from './common/BenFn'
import WimCookie from './components/WimCookie.vue'
import { BenHash } from './js/BenHash.ts'

export default {
  components: { WimCookie },
  props: {
    type: { default: null as any, required: false },
  },
  setup() {
    const isMobile = BenFn.isMobileByWidth()
    const lang = window['$BenQuery'] || {}
    const state = reactive({
      name: 'IMContainer',
      isMobile,
      cookieIndex: null as any,
      cookieOption: null as any,
      showWin: false,
      winDom: null as HTMLElement | null,
      bodyDom: null as HTMLElement | null,
      messageList: [] as Array<any>,
      textareaPlaceholder: _getLang('pleaseInput'),
      sending: false,
      messageToSend: '',
      sendError: '',
      textDisabled: false,
      showSend: false,
      unread: 0,
      domAi: null as null | HTMLElement[],
      domAiCount: null as null | HTMLElement[],
      images: {
        logo: '/logo.webp',
        you: '/chat/you.webp',
      },
      lang,
    })

    watch(() => state.unread, _updateAiCount)

    watchEffect(() => {
      state.showSend = state.messageToSend !== '' && state.sending === false
      state.textDisabled = state.sending === true
    })

    watchEffect(() => {
      let index = -1
      for (const item of state.messageList) {
        index++
        if (item.$isCustomer === true) {
          state.cookieIndex = index
          break
        }
      }
    })

    onMounted(async () => {
      if (state.isMobile === false) BenModalFn.init(state.winDom!, {})
      const { messages, unread, cookieOption } = WimFn.init()
      state.messageList = messages
      state.unread = unread
      state.cookieOption = cookieOption
      _updateStoreList()
      WimFn.updateUnread(state.unread)
      WimFn.onStoreChange(_onStoreUnreadChange, _onStoreMessagesChange, _onStoreCookieAcceptChange)
      WimFn.onMessageReply(_onMessageReply)
      _winScrollToBottom()
      state.domAi = Array.from(document.querySelectorAll('[ai-message]'))
      state.domAiCount = Array.from(document.querySelectorAll('[ai-message-count]'))
      _bindAiClickEvent()
      _addHashChangeEvent()
    })

    function _updateAiCount(unread) {
      state.domAiCount?.forEach((item) => {
        item.setAttribute('ai-message-count', unread + '')
        item.textContent = unread + ''
      })
    }

    function _bindAiClickEvent() {
      state.domAi?.forEach((item) => {
        item.addEventListener('click', fn.showChatWin)
      })
    }

    function _onStoreUnreadChange(unread) {
      state.unread = unread
    }

    function _onStoreCookieAcceptChange(cookieOption) {
      state.cookieOption = cookieOption
    }

    function _onStoreMessagesChange(messages) {
      state.messageList = messages
      _winScrollToBottom()
    }

    function _updateStoreList() {
      WimFn.updateStoreList(state.messageList)
    }

    function _addHashChangeEvent() {
      BenHash.onLeave('m-chat', () => {
        state.showWin = false
        document.documentElement.classList.remove('scroll-locked-chat')
      })
    }

    async function _onMessageReply(messages) {
      state.messageList = [...state.messageList, ...messages]
      _updateStoreList()
      if (state.showWin === false) {
        state.unread += messages.length
        WimFn.updateUnread(state.unread)
      }
      _winScrollToBottom()
    }

    async function _winScrollToBottom() {
      await nextTick()
      state.bodyDom?.scrollTo({ top: 1000000, behavior: 'smooth' })
    }

    function _getLang(key: string) {
      return lang[key] || key
    }

    const fn = {
      test() {},
      getLang(key) {
        return _getLang(key)
      },
      async sendMessage(message: string, { showWin = true } = {}) {
        if (!message) return
        if (showWin) fn.showChatWin()
        state.messageToSend = message
        await nextTick()
        return await fn.sendBtnClick()
      },
      showCookie(index) {
        return state.cookieIndex === index
      },
      onCookieAccept() {
        state.cookieOption = true
        WimFn.cookieAccpet()
      },
      onCookieReject() {
        state.cookieOption = false
        WimFn.cookieReject()
      },
      showChatWin() {
        WimFn.addTrack('ShowChat')
        state.showWin = true
        state.unread = 0
        WimFn.updateUnread(0)
        BenHash.push('m-chat')
        document.documentElement.classList.add('scroll-locked-chat')
      },
      closeChatWin() {
        WimFn.addTrack('CloseChat')
        window.history.back()
      },
      async sendBtnClick() {
        if (state.showSend === false) return
        const message = state.messageToSend.trim()
        state.sending = true
        const rs = await WimFn.sendMessage(message)
        state.sending = false
        if (rs === false) {
          state.sendError = _getLang('tipSendError')
          setTimeout(() => {
            state.sendError = ''
          }, 3000)
        } else {
          state.messageToSend = ''
          const list = BenFn.clone(state.messageList)
          state.messageList = WimFn.updateMessageListAfterSendSuccess(list, message)
          _updateStoreList()
          _winScrollToBottom()
        }
        return rs
      },
    }

    return { ...VueFn, ...toRefs(state), state, ...fn }
  },
}
